import { render, staticRenderFns } from "./PlaygroundSubheading.vue?vue&type=template&id=63fcb558&"
import script from "./PlaygroundSubheading.vue?vue&type=script&lang=js&"
export * from "./PlaygroundSubheading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports